module.exports = __webpack_public_path__ + "static/media/profile_update.9b28bfd5.png";